import React from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/core';

export default function StorageBoxGridDndCard({
  item,
  disabled,
  folderFileDropId,
  onFolderFileDragOver,
  onFolderFileDragLeave,
  onFolderFileDrop,
  children,
}) {
  const isFolder = item.type === 'folder';
  const fileDropActive = isFolder && folderFileDropId === item.itemId;

  const { attributes, listeners, setNodeRef: setDragRef, isDragging } = useDraggable({
    id: item.itemId,
    data: { item },
    disabled,
  });

  const { setNodeRef: setDropRef, isOver } = useDroppable({
    id: isFolder ? `folder-drop:${item.itemId}` : `grid-file:${item.itemId}`,
    disabled: disabled || !isFolder,
  });

  const setRefs = (node) => {
    setDragRef(node);
    if (isFolder) setDropRef(node);
  };

  return (
    <div
      ref={setRefs}
      className={[
        isDragging ? 'sb-drive-card--dragging' : '',
        isFolder && (isOver || fileDropActive) ? 'sb-drive-card--drop-target' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onDragOver={isFolder ? (e) => onFolderFileDragOver?.(e, item.itemId) : undefined}
      onDragLeave={isFolder ? (e) => onFolderFileDragLeave?.(e, item.itemId) : undefined}
      onDrop={isFolder ? (e) => onFolderFileDrop?.(e, item.itemId) : undefined}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
}
